import { PageOptions } from './../../app/shared/data-table/data-table.interface';
import { BaseHttpService } from 'src/app/shared/base-http/base-http.service';
import { Injectable } from '@angular/core';
import { config } from '../../config/config';
import { getEnv } from '../utility';


@Injectable()
export class ReasonCodeMaintenanceApiService {
    constructor(
        private http: BaseHttpService
    ) { }

    public getReasonCodes(pageOptions?: PageOptions) {
        pageOptions = pageOptions || {
            page: 0,
            order: 'asc',
            size: 10,
            sort: 'reasonCode',
        };

        return this.http
            .get(`${config.tprecmApiBaseUrl[getEnv()]}maint/reason-code?`
                + `page=${pageOptions.page}&size=${pageOptions.size}&sort=${pageOptions.sort}&order=${pageOptions.order}`)
    }

    public saveReasonCode(reasonCode) {
        return this.http
            .put(`${config.tprecmApiBaseUrl[getEnv()]}maint/reason-code`, reasonCode);
    }

    public createReasonCode(reasonCode) {
        return this.http
            .post(`${config.tprecmApiBaseUrl[getEnv()]}maint/reason-code`, reasonCode);
    }

    public deleteReasonCode(id) {
        return this.http
            .delete(`${config.tprecmApiBaseUrl[getEnv()]}maint/reason-code/${id}`);
    }
}
